/**
 * This module must be kept as barebones as possible, as it cannot be cache-busted and must
 * be served without any caching. It should only contain lazy loading wrappers for the components
 * you wish to expose.
 */

// core-js must be at the top of every webpack entry
// point for polyfills to be present in the build
import 'core-js/stable';

import { lazy } from 'react';

/**
 * This is an example of a default export module. You would load this within the
 * parent application like so:
 * @example
 * ```
 * import { FederatedModule } from '@zenbusiness/application-commons-federation';
 *
 * <FederatedModule
 *   src="/mfe/x/static/js/remoteEntry.js"
 *   globalScope="AppTemplateUi"
 * />
 * ```
 */
const DefaultEntry = lazy(() => import(/* webpackChunkName: 'remoteEntry-default' */ './Default'));
export default function Default(props) {
  return <DefaultEntry {...props} />;
}

const VeloQAEntry = lazy(
  () => import(/* webpackChunkName: 'remoteEntry-velo-qa' */ './entries/VeloQAEntry')
);

export function VeloQA(props) {
  return <VeloQAEntry {...props} />;
}
